import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Tabs,
  Tab,
  Select,
  MenuItem,
  Typography,
  Checkbox,
  FormControlLabel
} from "@mui/material";
import InvoiceProduct from "../../Empresa/NuevaFactura/InvoiceProduct";

const PurchaseDetail = ({
  purchaseData,
  onPurchaseDataChange,
  setPayments,
  productRows,
  setProductRows,
  productDescripcion,
  setProductDescripcion
}) => {
  const [tabValue, setTabValue] = useState(0);
  const [sinMovimiento, setSinMovimiento] = useState(false);

  useEffect(() => {
    setPayments([]);
  }, [setPayments]);

  useEffect(() => {
    if (purchaseData?.sin_movimiento_inventario !== undefined) {
      setSinMovimiento(purchaseData.sin_movimiento_inventario);
    }
  }, [purchaseData]);

  const handleSinMovimiento = (e) => {
    const checked = e.target.checked;
    setSinMovimiento(checked);
    onPurchaseDataChange((prev) => ({
      ...prev,
      sin_movimiento_inventario: checked
    }));
  };

  return (
    <Box sx={{ mx: "auto", mt: 3 }}>
      <Paper
        sx={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
        }}
      >
        <Box
          sx={{
            p: 2,
            display: "flex",
            alignItems: "center",
            gap: 3,
            borderBottom: "1px solid #e0e0e0"
          }}
        >
          <Typography sx={{ fontWeight: 600 }}>Bodega:</Typography>

          <Select value="PRINCIPAL" size="small" disabled sx={{ width: 240 }}>
            <MenuItem value="PRINCIPAL">Bodega principal</MenuItem>
          </Select>

          <FormControlLabel
            control={
              <Checkbox
                checked={sinMovimiento}
                onChange={handleSinMovimiento}
              />
            }
            label="Sin movimiento de inventario"
          />
        </Box>

        <Tabs
          value={tabValue}
          onChange={(_, v) => setTabValue(v)}
          variant="scrollable"
          scrollButtons={false}
          sx={{
            backgroundColor: "#1565C0",
            "& .MuiTab-root": {
              color: "#fff",
              textTransform: "none",
              fontWeight: 600,
              minHeight: "48px",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px"
            },
            "& .Mui-selected": {
              backgroundColor: "#fff",
              color: "#1565C0",
              borderTop: "4px solid #1565C0",
              borderLeft: "4px solid #1565C0",
              borderRight: "4px solid #1565C0",
              borderBottom: "none",
              marginTop: "5px",
              marginLeft: "10px"
            },
            "& .MuiTabs-indicator": { display: "none" }
          }}
        >
          <Tab label="Productos" />
        </Tabs>

        <Box sx={{ p: 3 }}>
          {tabValue === 0 && (
            <InvoiceProduct
              rows={productRows}
              setRows={setProductRows}
              descripcion={productDescripcion}
              setDescripcion={setProductDescripcion}
              onProductDataChange={onPurchaseDataChange}
            />
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default PurchaseDetail;